import { render } from "./InfiniteScrollSelect.vue?vue&type=template&id=0b196d66&scoped=true"
import script from "./InfiniteScrollSelect.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollSelect.vue?vue&type=script&lang=js"

import "./InfiniteScrollSelect.vue?vue&type=style&index=0&id=0b196d66&lang=less&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b196d66"]])

export default __exports__